import { Injectable } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import { PriceCalculationService } from './price-calculation.service';
import { Subscription, VehicleInfoService } from '../components/index';
import { log } from 'util';
import { CommonDataService } from '../services/common-data.service';
import { Utils } from '../shared/utils';

// import { SummaryValidationService } from './summary-validation.service';

declare let alasql: any;


@Injectable()
export class SummaryService {
    private selectedColor;
    private selectedAdditionalColor;
    private selectedTrim;
    private selectedRim;
    private selectedUpholstery;
    private selectedExpColor;
    private selectedExpAdditionalColor;
    private selectedExpTrim;
    public savedConfig: any;
    public vehicleInfo: any;

    
    private selectedExpRim;
    private selectedExpUpholstery;
    public selectedCollectArray: any;
    public selectedNormalOptionsDictionary = {
        'selectedFactory': [], 'selectedLocal': [], 'selectedPackage': [], 'selectedLocalPackage': [], 'selectedVehicle': [],
        'selectedNationalType': [], 'basePrice': [], 'totalPrice': [], 'selectedStandard': []
    }
    public selectedExpertOptionsDictionary = {
        'selectedFactory': [], 'selectedLocal': [], 'selectedPackage': [], 'selectedLocalPackage': [], 'selectedStandard': []
    }
    public subscription: Subscription;
    constructor(private dataLoaderService: DataLoaderService, private vehicleInfoService: VehicleInfoService, private priceService: PriceCalculationService,private commonDataService : CommonDataService) {
        this.vehicleInfo = this.vehicleInfoService.extractData();
        this.selectedNormalOptionsDictionary.selectedNationalType = [[this.dataLoaderService.vehicleInfo.baumuster]];
        this.selectedNormalOptionsDictionary.selectedVehicle = [[this.vehicleInfo.vehicleDescription.split('+').join(' ')]];
        this.selectedNormalOptionsDictionary.basePrice = [[this.dataLoaderService.data.vehInfo[0].priceBpmBm]];
        this.getSelectedOptions();
    }

    getSelectedOptions() {
        this.subscription = this.priceService.notifyObservableNormalComp$.subscribe((selectedOption) => {
            if (selectedOption.fromComponent == "normalColor") {
                this.selectedColor = selectedOption.data;
            } else if (selectedOption.fromComponent == "normalAddColor") {
                this.selectedAdditionalColor = selectedOption.data;
            } else if (selectedOption.fromComponent == "normalTrim") {
                this.selectedTrim = selectedOption.data;
            } else if (selectedOption.fromComponent == "normalRim") {
                this.selectedRim = selectedOption.data;
            } else if (selectedOption.fromComponent == "normalUpholstery") {
                this.selectedUpholstery = selectedOption.data;
            } else if (selectedOption.fromComponent == "normalFactory") {
                this.selectedNormalOptionsDictionary.selectedFactory = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "normalLocal") {
                this.selectedNormalOptionsDictionary.selectedLocal = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "normalPackage") {
                this.selectedNormalOptionsDictionary.selectedPackage = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "normalLocalPackage") {
                this.selectedNormalOptionsDictionary.selectedLocalPackage = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "normalStandard") {
                this.selectedNormalOptionsDictionary.selectedStandard = (selectedOption.data[0]);
            }
        });
        this.subscription = this.priceService.notifyObservableExpertComp$.subscribe((selectedOption) => {
            if (selectedOption.fromComponent == "expertColor") {
                this.selectedColor = selectedOption.data;
            } else if (selectedOption.fromComponent == "expertAddColor") {
                if (selectedOption.data !== undefined)
                    this.selectedAdditionalColor = selectedOption.data;
            } else if (selectedOption.fromComponent == "expertUpholstery") {
                this.selectedUpholstery = selectedOption.data;
            } else if (selectedOption.fromComponent == "expertTrim") {
                this.selectedExpTrim = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertRim") {
                this.selectedExpRim = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertFactory") {
                this.selectedExpertOptionsDictionary.selectedFactory = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertLocal") {
                this.selectedExpertOptionsDictionary.selectedLocal = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertPackage") {
                this.selectedExpertOptionsDictionary.selectedPackage = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertLocalPackage") {
                this.selectedExpertOptionsDictionary.selectedLocalPackage = (selectedOption.data[0]);
            } else if (selectedOption.fromComponent == "expertStandard") {
                this.selectedExpertOptionsDictionary.selectedStandard = (selectedOption.data[0]);
            }

        });
    }

    mergingStdwithNormal() {
        for (let i in this.dataLoaderService.data.stdOpt) {
            if (this.dataLoaderService.data.stdOpt[i].selected) {
                this.selectedNormalOptionsDictionary.selectedFactory.push(this.dataLoaderService.data.stdOpt[i]);
            }
        }

        if (this.selectedRim !== undefined) {
            if (this.selectedRim.length > 0)
                this.selectedNormalOptionsDictionary.selectedFactory.push(this.selectedRim[0]);
        }
        if (this.selectedTrim !== undefined) {
            if (this.selectedTrim.length > 0)
                this.selectedNormalOptionsDictionary.selectedFactory.push(this.selectedTrim[0]);
        }
    }


    submitData() {
        debugger
        if(this.selectedColor== undefined || this.selectedColor.length==0){
            this.dataLoaderService.data.color.forEach(element => {
                if (element.selected === true) {
                    this.selectedColor.unshift(element);
                }
            });
        }
        if(this.selectedAdditionalColor== undefined || this.selectedAdditionalColor.length==0){
            this.dataLoaderService.data.additionalColor.forEach(element => {
                if (element.selected === true) {
                    this.selectedAdditionalColor.unshift(element);
                }
            });
        }
        if(this.selectedUpholstery== undefined || this.selectedUpholstery.length==0){
            this.dataLoaderService.data.upholstery.forEach(element => {
                if (element.selected === true) {
                    this.selectedUpholstery.unshift(element);
                }
            });
        }
        
        let configData: String;
        let tempData1, tempData2, tempData3, tempData4, tempData5, tempData6, tempData8: String;

        if (this.dataLoaderService.vehicleInfo.plant === undefined) {
            tempData1 = '\"plant\":\"\"';
        } else {
            tempData1 = '\"plant\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.plant);
        }
        if (this.dataLoaderService.vehicleInfo.internalVehicleId === undefined) {
            tempData2 = ',\"internalVehicleId\":\"\"';
        } else {
            tempData2 = ',\"internalVehicleId\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.internalVehicleId);
        }
        this.mergingStdwithNormal();

        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedAdditionalColor === undefined || this.selectedAdditionalColor[0] === undefined) {
                tempData6 = ',\"secondaryColor\":\"\"';
            } else {
                tempData6 = ',\"secondaryColor\":' + JSON.stringify(this.selectedAdditionalColor[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedAdditionalColor === undefined || this.selectedAdditionalColor[0] === undefined) {
                tempData6 = ',\"secondaryColor\":\"\"';
            } else {
                tempData6 = ',\"secondaryColor\":' + JSON.stringify(this.selectedAdditionalColor[0]);
            }
        }
        if (this.selectedColor == [] || this.selectedColor == undefined) {
            tempData2 = ',\"color\":\"\"';
        } else {
            tempData2 = ',\"color\":' + JSON.stringify(this.selectedColor[0])
        }
        if (this.selectedUpholstery == [] || this.selectedUpholstery == undefined) {
            tempData3 = ',\"upholstery\":\"\"';
        } else {
            tempData3 = ',\"upholstery\":' + JSON.stringify(this.selectedUpholstery[0])
        }
        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedRim === undefined) {
                tempData4 = ',\"rim\":\"\"';
            } else {
                tempData4 = ',\"rim\":' + JSON.stringify(this.selectedRim[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedRim[0] === undefined) {
                tempData4 = ',\"rim\":\"\"';
            } else {
                tempData4 = ',\"rim\":' + JSON.stringify(this.selectedRim[0]);
            }
        }

        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedTrim === undefined || this.selectedTrim === "" || this.selectedTrim.length === 0) {
                tempData8 = ',\"trim\":\"\"';
            } else {
                tempData8 = ',\"trim\":' + JSON.stringify(this.selectedTrim[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedTrim === undefined || this.selectedTrim === "" || this.selectedTrim.length === 0) {
                tempData8 = ',\"trim\":\"\"';
            } else {
                tempData8 = ',\"trim\":' + JSON.stringify(this.selectedTrim[0]);
            }
        }

        if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            for (let i in this.dataLoaderService.hiddenOptions){
                this.dataLoaderService.hiddenCodes.push(this.dataLoaderService.hiddenOptions[i].code);
            }
          
        // this.dataLoaderService.getOtherCodesConfig();
        // if  (this.dataLoaderService.hiddenCodesValidationRes  ==  undefined) {
        //      for  (let  i  =  0;  i  <  this.dataLoaderService.hiddenCodes.length;  i++) {
        //           for  (let  j  =  0;  j  <  this.dataLoaderService.amendOtherCodes.length;  j++) {
        //              if  (this.dataLoaderService.hiddenCodes[i]  ===  this.dataLoaderService.amendOtherCodes[j]) {
        //                  this.dataLoaderService.hiddenOptionCodes.push(this.dataLoaderService.hiddenCodes[i]); //hidden options
                       
        //              }
        //           }
        //      }
        // }  else  {
        //         for  (let  i  =  0;  i  <  this.dataLoaderService.hiddenCodesValidationRes.length;  i++) {
        //             this.dataLoaderService.hiddenOptionCodes.push(this.dataLoaderService.hiddenCodesValidationRes[i]); //hidden options 
        //      }
        // }
            

            // this.dataLoaderService.getSavedConfig();
            // for (let i = 0; i < this.dataLoaderService.hiddenOptions.length; i++) {
            //     for (let j = 0; j < this.dataLoaderService.hiddenOptionCodes.length; j++) {
            //         if (this.dataLoaderService.hiddenOptionCodes[j] === this.dataLoaderService.hiddenOptions[i].code) {
            //             this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.hiddenOptions[i]);
            //         }
            //     }
            // }
            // if (this.dataLoaderService.internalCodes != undefined) {
            // for (let i = 0; i < this.dataLoaderService.internalCodes.length; i++) {
            //     this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.internalCodes[i])
            //     }
            // }
            // else {
            //     this.dataLoaderService.internalCodes = this.dataLoaderService.amendInternalCodes;
            //     for (let i = 0; i < this.dataLoaderService.internalCodes.length; i++) {
            //         for (let j = 0; j < this.dataLoaderService.ppmInternalCodesAccept.length; j++) {
            //             if(this.dataLoaderService.internalCodes[i] == this.dataLoaderService.ppmInternalCodesAccept[j].code){
            //         this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.ppmInternalCodesAccept[j])//internal codes
                    
            //     }
            // }
            // }
            // }
            
            // this.dataLoaderService.hiddenOptionsList=  this.dataLoaderService.hiddenOptionsList.filter((el, i, a) => i === a.indexOf(el))
            // tempData5 = ',\"internalCodes\":' + JSON.stringify(this.dataLoaderService.hiddenOptionsList)z
            let mergeCodes = this.dataLoaderService.hiddenOptions.concat(this.dataLoaderService.internalCodes);
            tempData5 = ',\"internalCodes\":' + JSON.stringify(mergeCodes)
            
        }
        else {
            for (let i = 0; i < this.dataLoaderService.gccInternalCodesAccept.length; i++) {
                this.dataLoaderService.hiddenOptions.push(this.dataLoaderService.gccInternalCodesAccept[i])
            }
            this.dataLoaderService.hiddenOptions=  this.dataLoaderService.hiddenOptions.filter((el, i, a) => i === a.indexOf(el))
            tempData5 = ',\"internalCodes\":' + JSON.stringify(this.dataLoaderService.hiddenOptions)
        }

        configData = '{'
            + tempData1 + ',\"productIdERP\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.baumuster)
            + tempData2
            + tempData6
            + tempData3 
            + tempData4
            + tempData8
            + tempData5
            + ',\"factoryOptions\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedFactory)
            + ',\"localOptions\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedLocal)
            + ',\"factoryPackages\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedPackage)
            + ',\"localPackages\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedLocalPackage)
            + ',\"priceBpmBm\":' + this.priceService.priceDictionary.constantGlobalPrice
            + ',\"totalPrice\":' + this.priceService.priceDictionary.globalPrice
            + '}';
            console.log("configData----->", configData);
            
            return configData;

    }

    //niket
        submitDataNew() {
        if(this.selectedColor== undefined || this.selectedColor.length==0){
            this.dataLoaderService.data.color.forEach(element => {
                if (element.selected === true) {
                    this.selectedColor.unshift(element);
                }
            });
        }
        if(this.selectedAdditionalColor== undefined || this.selectedAdditionalColor.length==0){
            this.dataLoaderService.data.additionalColor.forEach(element => {
                if (element.selected === true) {
                    this.selectedAdditionalColor.unshift(element);
                }
            });
        }
        if(this.selectedUpholstery== undefined || this.selectedUpholstery.length==0){
            this.dataLoaderService.data.upholstery.forEach(element => {
                if (element.selected === true) {
                    this.selectedUpholstery.unshift(element);
                }
            });
        }
        
        let configData: String;
        let tempData1, tempData2, tempData3, tempData4, tempData5, tempData6, tempData8: String;

        if (this.dataLoaderService.vehicleInfo.plant === undefined) {
            tempData1 = '\"plant\":\"\"';
        } else {
            tempData1 = '\"plant\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.plant);
        }
        if (this.dataLoaderService.vehicleInfo.internalVehicleId === undefined) {
            tempData2 = ',\"internalVehicleId\":\"\"';
        } else {
            tempData2 = ',\"internalVehicleId\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.internalVehicleId);
        }
        this.mergingStdwithNormal();

        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedAdditionalColor === undefined || this.selectedAdditionalColor[0] === undefined) {
                tempData6 = ',\"secondaryColor\":\"\"';
            } else {
                tempData6 = ',\"secondaryColor\":' + JSON.stringify(this.selectedAdditionalColor[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedAdditionalColor === undefined || this.selectedAdditionalColor[0] === undefined) {
                tempData6 = ',\"secondaryColor\":\"\"';
            } else {
                tempData6 = ',\"secondaryColor\":' + JSON.stringify(this.selectedAdditionalColor[0]);
            }
        }
        if (this.selectedColor == [] || this.selectedColor == undefined) {
            tempData2 = ',\"color\":\"\"';
        } else {
            tempData2 = ',\"color\":' + JSON.stringify(this.selectedColor[0])
        }
        if (this.selectedUpholstery == [] || this.selectedUpholstery == undefined) {
            tempData3 = ',\"upholstery\":\"\"';
        } else {
            tempData3 = ',\"upholstery\":' + JSON.stringify(this.selectedUpholstery[0])
        }
        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedRim === undefined) {
                tempData4 = ',\"rim\":\"\"';
            } else {
                tempData4 = ',\"rim\":' + JSON.stringify(this.selectedRim[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedRim[0] === undefined) {
                tempData4 = ',\"rim\":\"\"';
            } else {
                tempData4 = ',\"rim\":' + JSON.stringify(this.selectedRim[0]);
            }
        }

        if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
            if (this.selectedTrim === undefined || this.selectedTrim === "" || this.selectedTrim.length === 0) {
                tempData8 = ',\"trim\":\"\"';
            } else {
                tempData8 = ',\"trim\":' + JSON.stringify(this.selectedTrim[0]);
            }
        } else if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            if (this.selectedTrim === undefined || this.selectedTrim === "" || this.selectedTrim.length === 0) {
                tempData8 = ',\"trim\":\"\"';
            } else {
                tempData8 = ',\"trim\":' + JSON.stringify(this.selectedTrim[0]);
            }
        }

        if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
            for (let i in this.dataLoaderService.hiddenOptions){
                this.dataLoaderService.hiddenCodes.push(this.dataLoaderService.hiddenOptions[i].code);
            }
          
        // this.dataLoaderService.getOtherCodesConfig();
        // if  (this.dataLoaderService.hiddenCodesValidationRes  ==  undefined) {
        //      for  (let  i  =  0;  i  <  this.dataLoaderService.hiddenCodes.length;  i++) {
        //           for  (let  j  =  0;  j  <  this.dataLoaderService.amendOtherCodes.length;  j++) {
        //              if  (this.dataLoaderService.hiddenCodes[i]  ===  this.dataLoaderService.amendOtherCodes[j]) {
        //                  this.dataLoaderService.hiddenOptionCodes.push(this.dataLoaderService.hiddenCodes[i]); //hidden options
                       
        //              }
        //           }
        //      }
        // }  else  {
        //         for  (let  i  =  0;  i  <  this.dataLoaderService.hiddenCodesValidationRes.length;  i++) {
        //             this.dataLoaderService.hiddenOptionCodes.push(this.dataLoaderService.hiddenCodesValidationRes[i]); //hidden options 
        //      }
        // }
            

            // this.dataLoaderService.getSavedConfig();
            // for (let i = 0; i < this.dataLoaderService.hiddenOptions.length; i++) {
            //     for (let j = 0; j < this.dataLoaderService.hiddenOptionCodes.length; j++) {
            //         if (this.dataLoaderService.hiddenOptionCodes[j] === this.dataLoaderService.hiddenOptions[i].code) {
            //             this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.hiddenOptions[i]);
            //         }
            //     }
            // }
            // if (this.dataLoaderService.internalCodes != undefined) {
            // for (let i = 0; i < this.dataLoaderService.internalCodes.length; i++) {
            //     this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.internalCodes[i])
            //     }
            // }
            // else {
            //     this.dataLoaderService.internalCodes = this.dataLoaderService.amendInternalCodes;
            //     for (let i = 0; i < this.dataLoaderService.internalCodes.length; i++) {
            //         for (let j = 0; j < this.dataLoaderService.ppmInternalCodesAccept.length; j++) {
            //             if(this.dataLoaderService.internalCodes[i] == this.dataLoaderService.ppmInternalCodesAccept[j].code){
            //         this.dataLoaderService.hiddenOptionsList.push(this.dataLoaderService.ppmInternalCodesAccept[j])//internal codes
                    
            //     }
            // }
            // }
            // }
            
            // this.dataLoaderService.hiddenOptionsList=  this.dataLoaderService.hiddenOptionsList.filter((el, i, a) => i === a.indexOf(el))
            // tempData5 = ',\"internalCodes\":' + JSON.stringify(this.dataLoaderService.hiddenOptionsList)

            // let mergeCodes = this.dataLoaderService.hiddenOptions.concat(this.dataLoaderService.internalCodes);
            // tempData5 = ',\"internalCodes\":' + JSON.stringify(mergeCodes)

            // let mergeCodes = this.dataLoaderService.hiddenOptions.concat(this.dataLoaderService.internalCodes);
            tempData5 = ',\"internalCodes\":' + JSON.stringify(this.dataLoaderService.internalCodes)
            
        }
        else {
            for (let i = 0; i < this.dataLoaderService.gccInternalCodesAccept.length; i++) {
                this.dataLoaderService.hiddenOptions.push(this.dataLoaderService.gccInternalCodesAccept[i])
            }
            this.dataLoaderService.hiddenOptions=  this.dataLoaderService.hiddenOptions.filter((el, i, a) => i === a.indexOf(el))
            tempData5 = ',\"internalCodes\":' + JSON.stringify(this.dataLoaderService.hiddenOptions)
        }

        configData = '{'
            + tempData1 + ',\"productIdERP\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.baumuster)
            + tempData2
            + tempData6
            + tempData3 
            + tempData4
            + tempData8
            + tempData5 
            + ',\"factoryOptions\":' + JSON.stringify(this.dataLoaderService.hiddenOptions.concat(this.selectedNormalOptionsDictionary.selectedFactory))
            + ',\"localOptions\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedLocal)
            + ',\"factoryPackages\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedPackage)
            + ',\"localPackages\":' + JSON.stringify(this.selectedNormalOptionsDictionary.selectedLocalPackage)
            + ',\"priceBpmBm\":' + this.priceService.priceDictionary.constantGlobalPrice
            + ',\"totalPrice\":' + this.priceService.priceDictionary.globalPrice
            + '}';
            return configData;

    }

    submitSpecialModeData() {
        let vehDesc = this.dataLoaderService.data.vehInfo[0].vehicle.split('+').join(' ');
        let colorObj = {};
        let configData: String;
        let tempData1, tempData2, tempData3, tempData4, tempData5, tempData6, tempData7, tempData8: String;

        if (this.dataLoaderService.vehicleInfo.baumuster === undefined) {
            tempData1 = '\"productIdERP\":\"\"';
        } else {
            tempData1 = '\"productIdERP\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.baumuster);
        }
        if (vehDesc === undefined) {
            tempData2 = ',\"vehicle\":\"\"';
        } else {
            tempData2 = ',\"vehicle\":' + JSON.stringify(this.dataLoaderService.data.vehInfo[0].vehicle.split('+').join(' '));
        }
        if (this.dataLoaderService.vehicleInfo.pricingDate === undefined) {
            tempData6 = ',\"pricingDate\":\"\"';
        } else {
            tempData6 = ',\"pricingDate\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.pricingDate.substring(6) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(0, 4));
        }
        if (this.dataLoaderService.vehicleInfo.productionDate === undefined) {
            tempData7 = ',\"productionDate\":\"\"';
        } else {
            tempData7 = ',\"productionDate\":' + JSON.stringify(this.dataLoaderService.vehicleInfo.productionDate.substring(6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(0, 4));
        }
        if (this.selectedAdditionalColor === undefined) {
            tempData3 = ',\"secondaryColor\":\"\"';
        }
        else if (this.selectedAdditionalColor[0] === "") {
            tempData3 = ',\"secondaryColor\":\"\"';
        }
        else {
            tempData3 = ',\"secondaryColor\":' + '{' + '\"code\"' + ':' + JSON.stringify(this.selectedAdditionalColor[0]) + '}';
        }
        if (this.selectedColor === undefined) {
            tempData4 = ',\"color\":\"\"';
        }
        else if (this.selectedColor[0] === "") {
            tempData4 = ',\"color\":\"\"';
        }
        else {
            tempData4 = ',\"color\":' + '{' + '\"code\"' + ':' + JSON.stringify(this.selectedColor[0]) + '}';
        }
        if (this.selectedUpholstery === undefined) {
            tempData5 = ',\"upholstery\":\"\"';
        }
        else if (this.selectedUpholstery[0] === "") {
            tempData5 = ',\"upholstery\":\"\"';

        } else {
            tempData5 = ',\"upholstery\":' + '{' + '\"code\"' + ':' + JSON.stringify(this.selectedUpholstery[0]) + '}';
        }
        let tempFac = {};
        let factoryArr = [];
        if (this.selectedNormalOptionsDictionary.selectedFactory != undefined) {
            this.selectedNormalOptionsDictionary.selectedFactory.forEach(element => {

                tempFac = '{' + '\"code\"' + ':' + JSON.stringify(element) + '}';
                factoryArr.push(tempFac);
            });
        }

        let tempLoc = {};
        let LocalArr = [];
        if (this.selectedNormalOptionsDictionary.selectedLocal != undefined) {
            this.selectedNormalOptionsDictionary.selectedLocal.forEach(element => {
                tempLoc = '{' + '\"code\"' + ':' + JSON.stringify(element) + '}';
                LocalArr.push(tempLoc);
            });
        }

        let tempPack = {};
        let PackageArr = [];
        if (this.selectedNormalOptionsDictionary.selectedPackage != undefined) {
            this.selectedNormalOptionsDictionary.selectedPackage.forEach(element => {
                tempPack = '{' + '\"code\"' + ':' + JSON.stringify(element) + '}';
                PackageArr.push(tempPack);
            });
        }

        configData = '{'
            + tempData1
            + tempData2 + tempData6 + tempData7
            + tempData4
            + tempData3
            + tempData5
            + ',\"factoryOptions\":' + '[' + factoryArr + ']'
            + ',\"localOptions\":' + '[' + LocalArr + ']'
            + ',\"factoryPackages\":' + '[' + PackageArr + ']'
            + '}';
        return configData;
    }

    getPrintData() {
        // to get missing color and upholestry
        if(this.selectedColor== undefined || this.selectedColor.length==0){
            this.dataLoaderService.data.color.forEach(element => {
                if (element.selected === true) {
                    this.selectedColor.unshift(element);
                }
            });
        }
        if(this.selectedUpholstery== undefined || this.selectedUpholstery.length==0){
            this.dataLoaderService.data.upholstery.forEach(element => {
                if (element.selected === true) {
                    this.selectedUpholstery.unshift(element);
                }
            });
        }
        let selectedData: any = [];

        this.selectedNormalOptionsDictionary.totalPrice = [[this.priceService.priceDictionary.globalPrice]];

        for (let i in this.selectedNormalOptionsDictionary.selectedNationalType) {

            if(this.dataLoaderService.vehicleInfo.language =='ja'){
                this.selectedNormalOptionsDictionary.selectedNationalType[i].value = this.selectedNormalOptionsDictionary.selectedNationalType;
                this.selectedNormalOptionsDictionary.selectedNationalType[i].type = this.commonDataService.jsonValue.labels.printNationalType;
            }
            else {
                this.selectedNormalOptionsDictionary.selectedNationalType[i].value = this.selectedNormalOptionsDictionary.selectedNationalType;

            this.selectedNormalOptionsDictionary.selectedNationalType[i].type = this.commonDataService.jsonValue.labels.nationalType;
            }
            selectedData.push(this.selectedNormalOptionsDictionary.selectedNationalType[i]);
        }
        for (let i in this.selectedNormalOptionsDictionary.selectedVehicle) {
            this.selectedNormalOptionsDictionary.selectedVehicle[i].value = this.selectedNormalOptionsDictionary.selectedVehicle;
            this.selectedNormalOptionsDictionary.selectedVehicle[i].type = this.commonDataService.jsonValue.labels.vehicle;
            selectedData.push(this.selectedNormalOptionsDictionary.selectedVehicle[i]);
        }
        if ((!this.dataLoaderService.flagDictionary.hidePriceForTW) && (!this.dataLoaderService.flagDictionary.hidePriceForJP) && (!this.dataLoaderService.flagDictionary.hidePriceForMX)) {
            for (let i in this.selectedNormalOptionsDictionary.basePrice) {
                this.selectedNormalOptionsDictionary.basePrice[i].value = this.selectedNormalOptionsDictionary.basePrice;
                this.selectedNormalOptionsDictionary.basePrice[i].type = this.commonDataService.jsonValue.labels.basePrice;
                selectedData.push(this.selectedNormalOptionsDictionary.basePrice[i]);
            }
            for (let i in this.selectedNormalOptionsDictionary.totalPrice) {
                this.selectedNormalOptionsDictionary.totalPrice[i].value = this.selectedNormalOptionsDictionary.totalPrice;
                this.selectedNormalOptionsDictionary.totalPrice[i].type = this.commonDataService.jsonValue.labels.totalPrice;
                selectedData.push(this.selectedNormalOptionsDictionary.totalPrice[i]);
            }
        }
        for (let i in this.selectedColor) {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            this.selectedColor[i].type =  this.commonDataService.jsonValue.headers.printColor;
            }
            else {
                this.selectedColor[i].type =  this.commonDataService.jsonValue.headers.color;
            }
            selectedData.push(this.selectedColor[i]);
        }
        for (let i in this.selectedUpholstery) {
            this.selectedUpholstery[i].type = this.commonDataService.jsonValue.headers.upholstery;
            selectedData.push(this.selectedUpholstery[i]);
        }
        for (let i in this.selectedRim) {
            this.selectedRim[i].type = this.commonDataService.jsonValue.headers.rim;
            selectedData.push(this.selectedRim[i]);
        }

        for (let i in this.selectedTrim) {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            this.selectedTrim[i].type = this.commonDataService.jsonValue.headers.printTrim;
            }
            else {
                this.selectedTrim[i].type = this.commonDataService.jsonValue.headers.trim;
            }
            selectedData.push(this.selectedTrim[i]);
        }
        if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {
            for (let i in this.selectedAdditionalColor) {
                if (this.dataLoaderService.vehicleInfo.language == 'ja') {
                this.selectedAdditionalColor[i].type = this.commonDataService.jsonValue.headers.printAdditionalColor;
                }
                else {
                    this.selectedAdditionalColor[i].type = this.commonDataService.jsonValue.headers.additionalColor; 
                }
                selectedData.push(this.selectedAdditionalColor[i]);
            }
        }
        for (let i in this.selectedNormalOptionsDictionary.selectedFactory) {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            this.selectedNormalOptionsDictionary.selectedFactory[i].type = this.commonDataService.jsonValue.headers.printFactoryOptions;
            }
            else {
                this.selectedNormalOptionsDictionary.selectedFactory[i].type = this.commonDataService.jsonValue.headers.factoryOptions;  
            }
            selectedData.push(this.selectedNormalOptionsDictionary.selectedFactory[i]);
        }
        for (let i in this.selectedNormalOptionsDictionary.selectedLocal) {
            this.selectedNormalOptionsDictionary.selectedLocal[i].type = this.commonDataService.jsonValue.headers.localOptions;
            selectedData.push(this.selectedNormalOptionsDictionary.selectedLocal[i]);
        }
        for (let i in this.selectedNormalOptionsDictionary.selectedPackage) {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            this.selectedNormalOptionsDictionary.selectedPackage[i].type = this.commonDataService.jsonValue.headers.printPackageOptions;
            }
            else {
                this.selectedNormalOptionsDictionary.selectedPackage[i].type = this.commonDataService.jsonValue.headers.packageOptions;
            }
            selectedData.push(this.selectedNormalOptionsDictionary.selectedPackage[i]);
        }
        for (let i in this.selectedNormalOptionsDictionary.selectedLocalPackage) {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            this.selectedNormalOptionsDictionary.selectedLocalPackage[i].type = this.commonDataService.jsonValue.headers.printPackageOptions;
            }
            else {
                this.selectedNormalOptionsDictionary.selectedLocalPackage[i].type = this.commonDataService.jsonValue.headers.packageOptions;
            }
            selectedData.push(this.selectedNormalOptionsDictionary.selectedLocalPackage[i]);
        }
        if (((this.dataLoaderService.vehicleInfo.orderingMarket === '839') && (!this.dataLoaderService.flagDictionary.hidePriceForJP)) || 
            ((this.dataLoaderService.vehicleInfo.orderingMarket === '901' || this.dataLoaderService.vehicleInfo.orderingMarket === '919') && (!this.dataLoaderService.flagDictionary.hideTdForAUNZSO)) ||
            (Utils.isCountryCA_N(this.vehicleInfo.orderingMarket) || Utils.isCountryCA_T(this.vehicleInfo.orderingMarket) || Utils.isCountryMX(this.vehicleInfo.orderingMarket)
            || Utils.isCountryEG(this.vehicleInfo.orderingMarket))) {
            for (let i in this.selectedNormalOptionsDictionary.selectedStandard) {
                this.dataLoaderService.data.stdOpt[i].type = this.commonDataService.jsonValue.headers.standardOptions;
                selectedData.push(this.dataLoaderService.data.stdOpt[i]);
            }
        }
        return selectedData;
    }

    printSelectedData() {
        let dataArray = this.getPrintData();
        let myWindow = window.open('Saved_Config', '', 'width=800,height=600');
        let table: any;
        let Td = '';
        let Td1 = '';
        let Th;
        let Th1 = '<tr><th width="200px";></th><th width="300px";></th>';
        
        if (this.dataLoaderService.flagDictionary.hidePriceForTW || this.dataLoaderService.flagDictionary.hidePriceForJP || this.dataLoaderService.flagDictionary.hidePriceForMX) {
            
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            Th = '<tr><th width="200px";>' + this.commonDataService.jsonValue.labels.printType +'</th>' + '<th width="75px";>'+ this.commonDataService.jsonValue.labels.printCode + '</th>' + '<th width="300px";>' + this.commonDataService.jsonValue.labels.printDescription + '</th></tr>';
            }
            else {
                Th = '<tr><th width="200px";>Type</th><th width="75px";>Code</th><th width="300px";>Description</th></tr>';
            }
        } else {
            if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            Th = '<tr><th width="200px";>' + this.commonDataService.jsonValue.labels.printType +'</th>' + '<th width="75px";>' + this.commonDataService.jsonValue.labels.printCode + '</th><th width="300px";>' + this.commonDataService.jsonValue.labels.printDescription + '</th>' + '<th width="50px";>' + this.commonDataService.jsonValue.labels.printPrice + '</th></tr>';
            }
            else {
                Th = '<tr><th width="200px";>Type</th><th width="75px";>Code</th><th width="300px";>Description</th><th width="50px";>Price</th></tr>';
            }
        }
        if (this.dataLoaderService.vehicleInfo.language == 'ja') {
            for (let i in dataArray) {
                if (dataArray[i].type != this.commonDataService.jsonValue.labels.printNationalType && dataArray[i].type != this.commonDataService.jsonValue.labels.vehicleDescription && dataArray[i].type != this.commonDataService.jsonValue.labels.basePrice
                    && dataArray[i].type != this.commonDataService.jsonValue.labels.totalPrice) {

                    if (this.dataLoaderService.flagDictionary.hidePriceForTW || this.dataLoaderService.flagDictionary.hidePriceForJP) {
                        Td += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                            '<td width="75px";>' + dataArray[i].code + '</td>' +
                            '<td width="300px";>' + dataArray[i].description + '</td>';
                    } else {
                        Td += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                            '<td width="75px";>' + dataArray[i].code + '</td>' +
                            '<td width="300px";>' + dataArray[i].description + '</td>' +
                            '<td width="75px";>' + dataArray[i].price + '</td></tr>';
                    }
                    
                }
                else {
                    Td1 += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                        '<td width="300px";>' + dataArray[i] + '</td>';

                }
            }
        }
        else {
            for (let i in dataArray) {
                if (dataArray[i].type != this.commonDataService.jsonValue.labels.nationalType && dataArray[i].type != this.commonDataService.jsonValue.labels.vehicleDescription && dataArray[i].type != this.commonDataService.jsonValue.labels.basePrice
                    && dataArray[i].type != this.commonDataService.jsonValue.labels.totalPrice) {

                    if (this.dataLoaderService.flagDictionary.hidePriceForTW || this.dataLoaderService.flagDictionary.hidePriceForJP || this.dataLoaderService.flagDictionary.hidePriceForMX) {
                    Td += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                        '<td width="75px";>' + dataArray[i].code + '</td>' +
                        '<td width="300px";>' + dataArray[i].description + '</td>';
                } else {
                    Td += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                        '<td width="75px";>' + dataArray[i].code + '</td>' +
                        '<td width="300px";>' + dataArray[i].description + '</td>' +
                        '<td width="75px";>' + dataArray[i].price + '</td></tr>';
                }
                }
                else {
                    Td1 += '<tr width="200px";><td>' + dataArray[i].type + '</td>' +
                        '<td width="300px";>' + dataArray[i] + '</td>';

                }
            }
        }
        myWindow.document.write('<table>' + Th1 + Td1 + '</table>');
        myWindow.document.write('<table>' + Th + Td + '</table>');
        myWindow.document.title = 'Saved_Configuration';
        myWindow.document.close();
        myWindow.focus();
        myWindow.print();
        myWindow.close();
    }
    exportSelectedDataToExcel() {

        let dataArray;
        dataArray = this.getPrintData();
        let excelStyle;

        if (this.dataLoaderService.flagDictionary.hidePriceForTW || this.dataLoaderService.flagDictionary.hidePriceForJP || this.dataLoaderService.flagDictionary.hidePriceForMX) {
            excelStyle = {
                sheetid: 'SAVED CONFIGURATION',
                headers: true,
                caption: {
                    title: 'SAVED CONFIGURATION',
                    style: 'font-size: 75px; color:blue;'
                },
                style: 'background:#ffffff',
                column: {
                    style: 'background:#1e90ff; font-size:12px; border: solid thin;'

                },

                columns: [
                    { columnid: 'type', title: 'Type', width: 200 },
                    { columnid: 'value', title: 'Value', width: 200 },
                    { columnid: 'code', title: 'Code', width: 100 },
                    { columnid: 'description', title: 'Description', width: 300 },

                ],
                row: {
                    style: function (sheet, row, rowidx) {
                        return 'background:' + (rowidx % 2 ? '#ffffff' : '#add8e6') + ';border: solid thin;';
                    },
                },

            };

        } else {
            excelStyle = {
                sheetid: 'SAVED CONFIGURATION',
                headers: true,
                caption: {
                    title: 'SAVED CONFIGURATION',
                    style: 'font-size: 75px; color:blue;'
                },
                style: 'background:#ffffff',
                column: {
                    style: 'background:#1e90ff; font-size:12px; border: solid thin;'

                },

                columns: [
                    { columnid: 'type', title: 'Type', width: 200 },
                    { columnid: 'value', title: 'Value', width: 200 },
                    { columnid: 'code', title: 'Code', width: 100 },
                    { columnid: 'description', title: 'Description', width: 300 },
                    { columnid: 'price', title: 'Price', width: 100 },
                ],
                row: {
                    style: function (sheet, row, rowidx) {
                        return 'background:' + (rowidx % 2 ? '#ffffff' : '#add8e6') + ';border: solid thin;';
                    },
                },

            };
        }
        alasql('SELECT * INTO XLS("Saved_Config.xls",?) FROM ?', [excelStyle, dataArray]);
    }

    mergingStdWithSelectedNormal() {
        let arr = [];
        this.selectedCollectArray = [];
        this.selectedCollectArray = arr.concat(
            this.selectedNormalOptionsDictionary.selectedStandard,
            this.selectedNormalOptionsDictionary.selectedFactory,
            this.selectedNormalOptionsDictionary.selectedPackage,
            this.selectedNormalOptionsDictionary.selectedLocal,
            this.selectedNormalOptionsDictionary.selectedLocalPackage,
            this.selectedRim,
            this.selectedTrim

        );
    }


    /**
     * This functionality is to store the selected values in the expert screen for validation.
     * @param none
     * @returns none
     */
    mergingStdWithSelectedExpert() {
        let arr = [];
        this.selectedCollectArray = [];
        this.selectedCollectArray = arr.concat(
            this.selectedNormalOptionsDictionary.selectedStandard,
            this.selectedExpertOptionsDictionary.selectedFactory,
            this.selectedExpertOptionsDictionary.selectedLocal,
            this.selectedExpertOptionsDictionary.selectedLocalPackage,
            this.selectedExpertOptionsDictionary.selectedPackage,
            this.selectedExpRim,
            this.selectedExpTrim
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/summary.service.ts